var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 32,
    viewBox: "0 0 45 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9844 32H11.9844C8.95104 32 6.35904 30.95 4.20838 28.85C2.05771 26.75 0.983043 24.1833 0.984376 21.15C0.984376 18.55 1.76771 16.2333 3.33438 14.2C4.90104 12.1667 6.95104 10.8667 9.48438 10.3C10.3177 7.23333 11.9844 4.75 14.4844 2.85C16.9844 0.95 19.8177 0 22.9844 0C26.8844 0 30.193 1.35867 32.9104 4.076C35.6277 6.79333 36.9857 10.1013 36.9844 14C39.2844 14.2667 41.193 15.2587 42.7104 16.976C44.2277 18.6933 44.9857 20.7013 44.9844 23C44.9844 25.5 44.109 27.6253 42.3584 29.376C40.6077 31.1267 38.483 32.0013 35.9844 32H24.9844V17.7L28.1844 20.8L30.9844 18L22.9844 10L14.9844 18L17.7844 20.8L20.9844 17.7V32Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCloud);
export default __webpack_public_path__ + "static/media/gray_cloud.d89082ff96bb703a96a4f6d52a3d42ac.svg";
export { ForwardRef as ReactComponent };